export const TAG_GROUP_IDS = {
  'Safety Equipment': 1,
  'Operating Equipment': 2,
  'Guest Amenities': 3,
  'Leisure & Entertainment Equipment': 4,
  Accessories: 5,
  Experiences: 6,
} as const;

export type TagGroupId = typeof TAG_GROUP_IDS[keyof typeof TAG_GROUP_IDS];
/** tag_group.name might change on future backend translation; prefer stable `tag_group.id` */
export type TagGroupName = keyof typeof TAG_GROUP_IDS;

export type Tag = {
  'id': number;
  'name': string;
  /** >= 1 else key is omitted */
  'units'?: number;
  'has_units': boolean;
};

/** Returned by listing-api */
export type TagGroup = {
  'group_id': TagGroupId;
  'name': TagGroupName;
  'max_tags': number;
  'tags': Tag[];
};

/** Minimal returned by search api */
export type TagGroupSearchApi = {
  group_id: TagGroupId;
  name: TagGroupName;
  tags: {
    name: string;
    units?: number;
  }[];
};

export type Tags = {
  allAvailableTags: TagGroup[];
  listingTags: TagGroup[];
};

export type TagSelection = {
  tag_id: number;
  units: number; // 0 for all tags by default, >0 for tags for which user set units
};
